
























import {
  Component,
  Prop,
  Vue,
  Watch,
  Model,
  Emit
} from "vue-property-decorator";

@Component({})
export default class FormSelect extends Vue {
  /* -------------- prop ------------- */
  @Prop(String) placeholder?: string; // 占位符
  @Prop(Array) optionsList!: []; // 选项数据
  @Prop({ default: "value" }) optionKey!: string; // 选项识别key名
  @Prop({ default: "label" }) optionLabel!: string; // 选项识别label名
  @Prop(Array) otherClickDom!: HTMLElement[]; // 点击不会触发clickOutSideEvent事件元素列表

  /* -------------- Model ------------- */
  @Model("input", {
    type: [String, Number]
  })
  selectedValue?: string | number; // 选中值

  /* -------------- emit ------------- */
  @Emit("input")
  changeSlecetedValue (val: string | number) {
    return val;
  }

  /* -------------- data ------------- */
  selectOptionShow = false; // 选项框显示状态
  selectedlabel?: string; // 选中label

  /* -------------- watch ------------- */
  @Watch("selectedValue", { immediate: true })
  onSelectedValueChanged (val: string | number) {
    const selectedItem = this.optionsList.find(item => {
      return item[this.optionKey] === val;
    });
    if (selectedItem !== undefined) {
      this.selectedlabel = selectedItem[this.optionLabel];
    } else {
      this.selectedlabel = "";
    }
  }

  /* -------------- methods ------------- */
  clickOutSideEvent (e: Event) {
    let isOtherClickDom = false;
    if (e && e.target) {
      for (const dom of this.otherClickDom) {
        if (dom.contains(e.target as HTMLElement)) {
          isOtherClickDom = true;
          break;
        }
      }
    }
    if (!isOtherClickDom) {
      this.selectOptionShow = false;
    }
  }

  /**
   * @description: 切换下拉框转态
   */
  showOptions () {
    this.selectOptionShow = !this.selectOptionShow;
  }

  /* eslint-disable */
  selectedOption (item: any) {
    this.changeSlecetedValue(item[this.optionKey]);
    this.selectedlabel = item[this.optionLabel];
  }
  /* eslint-enable */
}
